import React, { Component } from 'react';
import '../../../../../styles/components/vehicle-register.scss';

class WeightTicketPrint extends Component {
  constructor(props) {
    super(props);
    this.printRef = React.createRef();
  }

  formatDate = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '';
      const day = date.getDate().toString().padStart(2, '0');
      const month = (date.getMonth() + 1).toString().padStart(2, '0');
      const year = date.getFullYear();
      return `${day}/${month}/${year}`;
    } catch (error) {
      return '';
    }
  };

  formatTime = (dateString) => {
    if (!dateString) return '';
    try {
      const date = new Date(dateString);
      if (isNaN(date.getTime())) return '';
      return date.toLocaleTimeString('en-US', {
        hour12: false,
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (error) {
      return '';
    }
  };

  getSafeValue = (obj, path, defaultValue) => {
    try {
      const value = path.split('.').reduce((o, key) => (o && o[key] !== undefined ? o[key] : undefined), obj);
      return value !== undefined ? value : defaultValue;
    } catch (error) {
      return defaultValue;
    }
  };

  render() {
    const { ticket = {}, driver = {}, vehicle = {}, deliverySite = {}, material , yard} = this.props;

    // Safe value extraction
    const gatePassNumber = this.getSafeValue(ticket, 'gatepass_number', 'N/A');
    const ticketNumber = this.getSafeValue(ticket, 'ticket_number', 'N/A');
    const bosNumber = this.getSafeValue(deliverySite, 'bos_number', 'N/A');

    const vehicleNumber = this.getSafeValue(vehicle, 'vehicle_number', 'N/A');
    const trailerNumber = this.getSafeValue(vehicle, 'trailer_number', 'N/A');
    const buyerName = this.getSafeValue(deliverySite, 'buyer_name', 'N/A');
    const loadFrom = this.getSafeValue(deliverySite, 'load_from', 'N/A');
    const loadTo = this.getSafeValue(deliverySite, 'load_to', 'N/A');
    const yardName = this.getSafeValue(yard, 'name', 'N/A');

    const driverName = this.getSafeValue(driver, 'name', 'N/A');

    const tareWeight = parseFloat(this.getSafeValue(ticket, 'tare_weight', 0));
    const grossWeight = parseFloat(this.getSafeValue(ticket, 'gross_weight', 0));
    const netWeight = parseFloat(this.getSafeValue(ticket, 'net_weight', 0));

    const entryTime = this.getSafeValue(ticket, 'entry_time', '');
    const exitTime = this.getSafeValue(ticket, 'exit_time', '');

    // Determine material name
    let materialName = material ||
      this.getSafeValue(ticket, 'delivery_site.material.name', '') ||
      this.getSafeValue(ticket, 'materialType', '') ||
      this.getSafeValue(ticket, 'materialName', '') ||
      'N/A';

    // Format weights
    const formatWeight = (weight) => {
      return `${weight.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    };

    // Current date and time
    const currentDate = new Date().toLocaleDateString('en-GB');
    const currentTime = new Date().toLocaleTimeString('en-US', { hour12: false, hour: '2-digit', minute: '2-digit' });

    return (
      <div
        ref={this.props.forwardedRef || this.printRef}
        className="bilingual-invoice"
      >
        <div className="invoice-wrapper">
          {/* Invoice Header */}
          <div className="invoice-header">
            <div className="company-info">
              <img
                src={process.env.PUBLIC_URL + '/assets/images/logo-org.png'}
                alt="Mzadcom"
                className="invoice-logo"
              />
            </div>

            <div className="company-text">
              <h1 className="company-name">Sold / Auctioned Material Gate Pass</h1>
              <h1 className="company-name-ar">تصريخ خروج بضائع المواد المباعة</h1>
            </div>

            <div className="invoice-title-section">
              <h2 className="invoice-title">WEIGHT INVOICE</h2>
              <h2 className="invoice-title-ar">فاتورة الوزن</h2>
              <div className="invoice-number">
                <div className="number-row">
                  <span className="label">Invoice No:</span>
                  <span className="value">{ticketNumber}</span>
                  <span className="label-ar">رقم الفاتورة</span>
                </div>
              </div>
            </div>
          </div>

          {/* Invoice Details */}
          <div className="invoice-details">
            <div className="details-section">
              <div className="detail-row">
                <div className="detail-item">
                  <span className="label">Bill of Sale No:</span>
                  <span className="value">{bosNumber}</span>
                  <span className="label-ar rtl-text">رقم فاتورة البيع :</span>
                </div>

                <div className="detail-item">
                  <span className="label">Gate Pass No:</span>
                  <span className="value">{gatePassNumber}</span>
                  <span className="label-ar rtl-text">رقم تصريح الدخول :</span>
                </div>
              </div>

              <div className="detail-row">
                <div className="detail-item">
                  <span className="label">Invoice Date:</span>
                  <span className="value">{currentDate}</span>
                  <span className="label-ar rtl-text">تاريخ الفاتورة :</span>
                </div>
                <div className="detail-item">
                  <span className="label">Invoice Time:</span>
                  <span className="value">{currentTime}</span>
                  <span className="label-ar rtl-text">وقت الفاتورة :</span>
                </div>
              </div>
            </div>
          </div>

          {/* Supplier & Buyer Info */}
          <div className="supplier-buyer-section">
            <div className="section-header">
              <h3>SUPPLIER & BUYER INFORMATION</h3>
              <h3 className="header-ar">معلومات المورد والمشتري</h3>
            </div>

            <div className="info-grid">
              <div className="info-column">
                <div className="info-item">
                  <div className="label-row">
                    <div className="label">Supplier's Name:</div>
                    <div className="value-row">
                      <div className="value">PDO</div>
                    </div>
                    <div className="label-ar">اسم المورد</div>
                  </div>

                </div>

                <div className="info-item">
                  <div className="label-row">
                    <div className="label">Material Description:</div>
                    <div className="value-row"><span className="value">{materialName}</span> </div>
                    <div className="label-ar">وصف المادة</div>
                  </div>

                </div>

                <div className="info-item">
                  <div className="label-row">
                    <div className="label">Load From:</div>
                    <div className="value-row">
                      <div className="value">{loadFrom}</div>
                    </div>
                    <div className="label-ar">التحميل إلى</div>
                  </div>
                </div>



                <div className="info-item">
                  <div className="label-row">
                    <div className="label">Vehicle Entry:</div>
                    <div className="value-row">
                      <div className="value">{this.formatDate(entryTime)} {this.formatTime(entryTime)}</div>
                    </div>
                    <div className="label-ar">وقت دخول المركبة</div>
                  </div>

                </div>

                <div className="info-item">
                  <div className="label-row">
                    <div className="label">Vehicle Number:</div>
                    <div className="value-row">
                      <div className="value">{vehicleNumber}</div>
                    </div>
                    <div className="label-ar">رقم المركبة</div>
                  </div>
                </div>

                                <div className="info-item">
                  <div className="label-row">
                    <div className="label">Trailer Number:</div>
                    <div className="value-row">
                      <div className="value">{trailerNumber}</div>
                    </div>
                    <div className="label-ar">رقم المقطورة</div>
                  </div>
                </div>
              </div>

              <div className="info-column">
                <div className="info-item">
                  <div className="label-row">
                    <div className="label">Buyer's Name:</div>
                    <div className="value-row">
                      <div className="value">{buyerName}</div>
                    </div>
                    <div className="label-ar">اسم المشتري</div>
                  </div>

                </div>

                <div className="info-item">
                  <div className="label-row">
                    <div className="label">Yard Name:</div>
                    <div className="value-row">
                      <div className="value">{yardName}</div>
                    </div>
                    <div className="label-ar"> اسم الفناء</div>
                  </div>
                </div>

                <div className="info-item">
                  <div className="label-row">
                    <div className="label">Load To:</div>
                    <div className="value-row">
                      <div className="value">{loadTo}</div>
                    </div>
                    <div className="label-ar">التحميل من</div>
                  </div>

                </div>

                <div className="info-item">
                  <div className="label-row">
                    <div className="label">Vehicle Exit:</div>
                    <div className="value-row">
                      <div className="value">{this.formatDate(exitTime)} {this.formatTime(exitTime)}</div>
                    </div>
                    <div className="label-ar">وقت خروج المركبة</div>
                  </div>

                </div>

                <div className="info-item">
                  <div className="label-row">
                    <div className="label">Driver Name:</div>
                    <div className="value-row">
                      <div className="value">{driverName}</div>
                    </div>
                    <div className="label-ar">اسم السائق</div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          {/* Weight Calculation Table */}
          <div className="weight-table-section">
            <div className="section-header">
              <h3>WEIGHT CALCULATION SUMMARY</h3>
              <h3 className="header-ar">ملخص حساب الوزن</h3>
            </div>

            <table className="weight-table">
              <thead>
                <tr>
                  <th>
                    <div className="th-en">Description</div>
                    <div className="th-ar">الوصف</div>
                  </th>
                  <th>
                    <div className="th-en">Weight (KG)</div>
                    <div className="th-a"><span className='rtl-text'>الوزن (كجم)</span> </div>
                  </th>
                  <th>
                    <div className="th-en">Time</div>
                    <div className="th-ar"><span className='rtl-text'> الوقت </span></div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="description">
                    <div className="desc-en">Tare Weight (Empty Vehicle)</div>
                    <div className="desc-ar rtl-text">الوزن الفارغ (المركبة الفارغة)  </div>
                  </td>
                  <td className="weight-value">{formatWeight(tareWeight)}</td>
                  <td className="time-cell">{this.formatTime(entryTime) || 'N/A'}</td>
                </tr>

                <tr>
                  <td className="description">
                    <div className="desc-en">Gross Weight (Loaded Vehicle)</div>
                    <div className="desc-ar rtl-text">الوزن الإجمالي (المركبة المحملة)</div>
                  </td>
                  <td className="weight-value">{formatWeight(grossWeight)}</td>
                  <td className="time-cell">{this.formatTime(exitTime) || 'N/A'}</td>
                </tr>

                <tr className="total-row">
                  <td className="description">
                    <div className="desc-en"><strong>NET WEIGHT (Material Weight)</strong></div>
                    <div className="desc-ar rtl-text"><strong>الوزن الصافي (وزن المادة)</strong></div>
                  </td>
                  <td className="weight-value total">
                    <strong>{formatWeight(netWeight)}</strong>
                  </td>
                  <td className="time-cell"></td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Authorization Section */}
          <div className="authorization-section">
            <div className="signatures-grid">
              <div className="signature-block">
                <h4 className="auth-title">WEIGHED & AUTHORIZED BY</h4>
                <h4 className="auth-title-ar">وزن وأذن بواسطة</h4>
                <div className="signature-area">
                  <div className="signature-line"></div>
                  <div className="signature-info">
                    <p className="auth-name">Mzadcom Operator</p>
                    <p className="auth-name-ar">موظف مزداكم</p>
                    <p className="auth-role">Authorized Weighing Officer</p>
                    <p className="auth-role-ar">موظف الوزن المخول</p>
                  </div>
                </div>
              </div>

              <div className="signature-block">
                <h4 className="auth-title">BUYER ACKNOWLEDGMENT</h4>
                <h4 className="auth-title-ar">إقرار المشتري</h4>
                <div className="signature-area">
                  <div className="signature-line"></div>
                  <div className="signature-info">
                    {/* <p className="auth-name">{driverName}</p> */}
                    <p></p>
                    <p></p>
                    <br />
                    <p className="auth-role">Buyer Supervisor</p>
                    <p className="auth-role-ar">مشرف المشتريات</p>
                  </div>
                </div>
              </div>

              <div className="signature-block seal-block">
                <h4 className="auth-title">COMPANY SEAL</h4>
                <h4 className="auth-title-ar">ختم الشركة</h4>
                <div className="seal-area">
                  <img
                    src={process.env.PUBLIC_URL + '/assets/images/seal.png'}
                    alt="Company Seal"
                    className="company-seal"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Footer Section */}
          <div className="footer-section">
            <div className="terms-section">
              <div className="terms-header">
                <h4>TERMS & CONDITIONS:</h4>
                <h4 className="terms-header-ar">الشروط والأحكام:</h4>
              </div>
              <div className="terms-content">
                <div className="term-item">
                  <p>1. This invoice is valid only with company seal and authorized signature.</p>
                  <p className="term-ar">1. هذه الفاتورة صالحة فقط مع ختم الشركة والتوقيع المخول.</p>
                </div>
                <div className="term-item">
                  <p>2. This Permit Is Valid for One Week From Issuing Date.</p>
                  <p className="term-ar">2. هذا التصريح صالح لمدة أسبوع واحد من تاريخ إصداره</p>
                </div>
              </div>
            </div>

            <div className="footer-info">
              <div className="print-info">
                <div className="barcode-row">
                  <p className="barcode">INVOICE #{ticketNumber}</p>
                </div>
                <div className="print-time-row">
                  <p className="print-time">Printed: {currentDate} at {currentTime}</p>
                </div>
              </div>

              <div className="contact-info">
                <p>Mzadcom Smart Auction Solution LLC</p>
                <p>Email: info@mzadcom.com</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

// Forward ref for printing
const ForwardedWeightTicketPrint = React.forwardRef((props, ref) => (
  <WeightTicketPrint {...props} forwardedRef={ref} />
));

export default ForwardedWeightTicketPrint;